module.exports = __webpack_public_path__ + "static/resume-212c8f565882d1625825984e4604daab.pdf";